import React, { useState, useEffect, useRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import moment, { duration } from "moment";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Link, useHistory } from "react-router-dom";
import JoinNow from "../../assets/Join Now.svg";
import KnowMore from "../../assets/Know More.svg";
import Share from "../../assets/Share.svg";
import Registered from "../../assets/Registered.svg";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

const UpcomingWebinarRow = ({
  webinar,
  index,
  registerWebinar,
  disableBtn,
}) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [timerHours, setTimerHours] = useState(0);
  const [timerMinutes, setTimerMinutes] = useState(0);
  const [timerSeconds, setTimerSeconds] = useState(0);
  const [timerDays, setTimerDays] = useState(0);
  const [selectedWebinar, setSelectedWebinat] = useState("");
  const [isWebinarStarted, setIsWebinarStarted] = useState(false);
  let interval = useRef();
  let countDownTime = "";
  let dots = "...";

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  const startTimer = () => {
    let startTime = webinar.webinar_start_date_time.split("+")[0];
    startTime = moment(startTime).format("");
    interval = setInterval(() => {
      const duration = moment.duration(moment(startTime).diff(moment()));
      if (
        duration.days() <= 0 &&
        duration.hours() <= 0 &&
        duration.minutes() <= 0 &&
        duration.seconds() <= 0
      ) {
        clearInterval(interval);
        setTimerDays("0");
        setTimerHours("0");
        setTimerMinutes("0");
        setTimerSeconds("0");
        setIsWebinarStarted(true);
      } else {
        setTimerDays(duration.days());
        setTimerHours(duration.hours());
        setTimerMinutes(duration.minutes());
        setTimerSeconds(duration.seconds());
      }
    }, 1000);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const WebinarLink = () => {
    if (window.location.hostname === "dev.c2cassets.com") {
      return `https://webinar-dev.c2cassets.com/view-webinar/${localStorage.getItem(
        "id_token"
      )}/${userId}/${webinar.webinar_id}`;
    } else if (window.location.hostname === "qa.c2cassets.com") {
      return `https://webinar-qa.c2cassets.com/view-webinar/${localStorage.getItem(
        "id_token"
      )}/${userId}/${webinar.webinar_id}`;
    } else if (window.location.hostname === "uat.c2cassets.com") {
      return `https://webinar-uat.c2cassets.com/view-webinar/${localStorage.getItem(
        "id_token"
      )}/${userId}/${webinar.webinar_id}`;
    } else if (window.location.hostname === "www.connect2clinic.com") {
      return `https://Webinar.connect2clinic.com/view-webinar/${localStorage.getItem(
        "id_token"
      )}/${userId}/${webinar.webinar_id}`;
    } else {
      return `https://webinar-dev.c2cassets.com/view-webinar/${localStorage.getItem(
        "id_token"
      )}/${userId}/${webinar.webinar_id}`;
    }
  };

  const getJoinButton = (webinar) => {
    let is_allow = localStorage.getItem("register_for_upcoming_webinar_allow");
    if (webinar.is_doctor_registered === "False") {
      return (
        <button
          className="btn btn-sm primary-cta-button rounded-pill py-2 px-4 btn-width"
          onClick={() => {
            setSelectedWebinat(webinar.webinar_id);
            registerWebinar(webinar);
          }}
          disabled={
            is_allow == "false"
              ? true
              : selectedWebinar === webinar.webinar_id
              ? disableBtn
              : ""
          }
        >
          Register
        </button>
      );
    } else if (webinar.is_doctor_registered === "True") {
      startTimer();
      return (
        <>
          <button
            className="btn btn-sm primary-cta-button rounded-pill py-2 px-2 button-grp-desktop" //px-4
            // disabled={
            //   timerDays === 0 && timerHours < 1 && timerMinutes < 15
            //     ? false
            //     : true
            // }
          >
            {/* ${webinar.webinar_id} "d0af5c74-4204-49b5-93bb-8312ba7ef665"*/}
            <a href={WebinarLink()}>
              {/* {timerDays === 0 && timerHours < 1 ? "Join Now" : "Registered"} */}
              Go to Webinar
            </a>
          </button>
          <div className="text-center">
            {isWebinarStarted ? (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#F969A4" }}
              >
                Webinar Started
              </small>
            ) : timerDays > 0 ? (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#F969A4" }}
              >
                Starts in {timerDays} days
              </small>
            ) : (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#F969A4" }}
              >
                Starts in {timerHours < 10 ? `0${timerHours}` : timerHours}:
                {timerMinutes < 10 ? `0${timerMinutes}` : timerMinutes}:
                {timerSeconds < 10 ? `0${timerSeconds}` : timerSeconds}
              </small>
            )}
          </div>
        </>
      );
    }
  };

  function getActions() {
    return (
      <div className="d-flex">
        {/* <button className="btn btn-sm primary-cta-button rounded-pill py-2 px-4 mx-2 ">
          Join Now
        </button> */}
        <span className="pr-4">{getJoinButton(webinar)}</span>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleMenuClick}
          style={{ padding: "0px" }}
        >
          <MoreHorizIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              // maxHeight: ITEM_HEIGHT * 4.5,
              // width: "20ch",
              color: "#17bae0",
              top: "75px",
              left: "900px",
            },
          }}
        >
          <MenuItem onClick={handleMenuClose}>
            <div
              onClick={() => {
                history.push({
                  pathname: `/doctor/account/webinars/know-more/${webinar.webinar_id}`,
                  // state: {
                  //   webinar_id: webinar.webinar_id,
                  // },
                });
              }}
            >
              <span className="pl-2">Know More</span>
            </div>
          </MenuItem>
          {/* <MenuItem onClick={handleMenuClose}>
            <div
            //   onClick={() => {
            //     setShowAgendaDelete(true);
            //   }}
            >
              <span className="pl-2">Share this Webinar</span>
            </div>
          </MenuItem> */}
        </Menu>
      </div>
    );
  }

  const getJoinButtonMobile = (webinar) => {
    let is_allow = localStorage.getItem("register_for_upcoming_webinar_allow");

    if (webinar.is_doctor_registered === "False") {
      //True
      return (
        <button
          className="d-flex flex-column"
          onClick={() => {
            registerWebinar(webinar);
          }}
          disabled={is_allow == "false" ? true : false}
        >
          <img
            className="m-auto"
            src={JoinNow}
            width={24}
            height={24}
            onClick={() =>
              is_allow == "false" ? null : registerWebinar(webinar)
            }
            alt="join"
          />
          Register
        </button>
      );
    } else if (webinar.is_doctor_registered === "True") {
      startTimer();
      return (
        <>
          <button
            className="d-flex flex-column"
            disabled={
              timerDays === 0 && timerHours < 1 && timerMinutes < 15
                ? false
                : true
            }
          >
            <a className="d-flex flex-column" href={WebinarLink()}>
              {timerDays === 0 && timerHours < 1 && timerMinutes < 15 ? (
                <img className="m-auto" src={JoinNow} width={24} height={24} />
              ) : (
                <img
                  className="m-auto"
                  src={Registered}
                  width={24}
                  height={24}
                />
              )}
              {/* {timerDays === 0 && timerHours < 1 ? "Join Now" : "Registered"} */}
              Go to Webinar
            </a>
            {/* {timerDays === 0 && timerHours < 1 ? "Login" : "Registered"} */}
          </button>
          <div className="text-center" style={{ lineHeight: "0.6" }}>
            {isWebinarStarted ? (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#A3A9B7" }}
              >
                Webinar Started
              </small>
            ) : timerDays > 0 ? (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#A3A9B7" }}
              >
                Starts in {timerDays} days
              </small>
            ) : (
              <small
                className="cursor-pointer textLink text-center"
                style={{ color: "#A3A9B7" }}
              >
                Starts in {timerHours < 10 ? `0${timerHours}` : timerHours}:
                {timerMinutes < 10 ? `0${timerMinutes}` : timerMinutes}:
                {timerSeconds < 10 ? `0${timerSeconds}` : timerSeconds}
              </small>
            )}
          </div>
        </>
      );
    }
  };

  const getMobileActionSheet = () => {
    return (
      <div className="row mobile-btn-groups">
        <div className="col d-flex justify-content-around">
          {" "}
          {/**between */}
          <div className="p-2">
            {getJoinButtonMobile(webinar)}
            {/* <img className="m-auto" src={JoinNow} width={24} height={24} />
            Join Now */}
          </div>
          <div className="p-2">
            <button className="d-flex flex-column">
              <img
                className="m-auto"
                src={KnowMore}
                width={24}
                height={24}
                onClick={() => {
                  history.push({
                    pathname: `/doctor/account/webinars/know-more/${webinar.webinar_id}`,
                    // state: {
                    //   webinar_id: webinar.webinar_id,
                    // },
                  });
                }}
              />
              Know More
            </button>
          </div>
          {/* <div className="p-2">
            <button className=" d-flex flex-column">
              <img className="m-auto" src={Share} width={24} height={24} />
              Share
            </button>
          </div> */}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="row previous-patient  patient-row-individual-row align-items-center shadow-sm my-lg-2 mx-lg-2 border rounded-sm my-2 mx-0 text-md-left text-center">
        <div className="col">{webinar.webinar_title}</div>
        <div className="col">
          {/* {webinar.moderator_first_name !== "" &&
          webinar.moderator_last_name !== ""
            ? `${webinar.moderator_prefix_name + " "}${
                webinar.moderator_first_name + " "
              }${
                webinar.moderator_middle_name
                  ? webinar.moderator_middle_name + " "
                  : " "
              }${webinar.moderator_last_name}`
            : " - "} */}
          {webinar.moderator_names && webinar.moderator_names.length > 0
            ? webinar.moderator_names
                .slice(0, 2)
                .map(
                  (data, index) =>
                    ` ${data.prefix_name} ${data.first_name} ${
                      data.middle_name ? data.middle_name : " "
                    } ${data.last_name}${
                      webinar.moderator_names.length > 1
                        ? webinar.moderator_names.length - 1 !== index
                          ? ","
                          : ""
                        : ""
                    }${
                      webinar.moderator_names.length > 2 && index == 1
                        ? "..."
                        : ""
                    }`
                )
            : "-"}
        </div>
        <div className="col">
          {
            <>
              <div>
                {moment(webinar.webinar_start_date_time.split("+")[0]).format(
                  "MMM DD, YYYY"
                )}
              </div>
              <div style={{ font: "normal normal normal 12px/21px Rubik" }}>
                {moment(webinar.webinar_start_date_time.split("+")[0]).format(
                  "hh:mm A"
                )}{" "}
                -
                {moment(webinar.webinar_end_date_time.split("+")[0]).format(
                  "hh:mm A"
                )}
              </div>
            </>
          }
        </div>
        <div className="col">{getActions()}</div>
      </div>

      <div
        key={index}
        className="previous-patient-mobile patient-row-individual-row shadow-sm border rounded-sm my-2 mx-2"
      >
        <div className="m-2">
          <div className="row">
            <div className="col patient-row-header">WEBINAR TITLE</div>
          </div>
          <div className="row mt-1">
            <div className="col" style={{ wordBreak: "break-all" }}>
              {webinar.webinar_title}
            </div>
          </div>
        </div>

        <div className="m-2">
          <div className="row">
            <div className="col patient-row-header">DATE & TIME</div>
            <div className="col patient-row-header">MODERATOR</div>
          </div>

          <div className="row mt-1">
            <div className={"col"}>
              {
                <>
                  <div>
                    {moment(
                      webinar.webinar_start_date_time.split("+")[0]
                    ).format("MMM DD, YYYY")}
                  </div>
                  <div style={{ font: "normal normal normal 12px/21px Rubik" }}>
                    {moment(
                      webinar.webinar_start_date_time.split("+")[0]
                    ).format("hh:mm A")}{" "}
                    -
                    {moment(webinar.webinar_end_date_time.split("+")[0]).format(
                      "hh:mm A"
                    )}
                  </div>
                </>
              }
            </div>
            <div className="col ">
              {webinar.moderator_names && webinar.moderator_names.length > 0
                ? webinar.moderator_names
                    .slice(0, 2)
                    .map(
                      (data, index) =>
                        ` ${data.prefix_name} ${data.first_name} ${
                          data.middle_name ? data.middle_name : " "
                        } ${data.last_name}${
                          webinar.moderator_names.length > 1
                            ? webinar.moderator_names.length - 1 !== index
                              ? ","
                              : ""
                            : ""
                        }${
                          webinar.moderator_names.length > 2 && index == 1
                            ? "..."
                            : ""
                        }`
                    )
                : "-"}
            </div>
          </div>
        </div>
        <hr className="mb-0" />
        <div className="text-center justify-content-center align-items-center">
          <div className="row">
            <div className="col">{getMobileActionSheet()}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingWebinarRow;
